import React, { Component } from "react";
import "./LandingPage.css";
import Entry from "./LandingPageEntry";
import { library } from "@fortawesome/fontawesome-svg-core";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faUser,
  faUsers,
  faUserEdit,
  faCalculator,
  faCog,
  faHome,
  faBuilding,
  faChartArea,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSearch,
  faUser,
  faUsers,
  faUserEdit,
  faCalculator,
  faCog,
  faHome,
  faBuilding,
  faChartArea,
  faQrcode
);

class LandingPage extends Component {
  gotoGraph = () => {
    this.props.history.push("/graph");
  };
  gotoView = () => {
    this.props.history.push("/view");
  };
  gotoAdd = () => {
    this.props.history.push("/new");
  };
  gotoCalculator = () => {
    this.props.history.push("/calc");
  };
  gotoAddBus = () => {
    this.props.history.push("/addbus");
  };
  gotoViewBus = () => {
    this.props.history.push("/viewbus");
  };
  gotoQrCode = () => {
    this.props.history.push("/qrcode");
  };

  render() {
    return (
      <div className="entry">
        <div className="group">
          <Entry
            name={"Add Tax Payer"}
            icon={<FontAwesomeIcon icon="user-edit" />}
            color={"orange"}
            navigate={this.gotoAdd}
          />
          <Entry
            name={"View Tax Payers"}
            icon={<FontAwesomeIcon icon="users" />}
            color={"green"}
            navigate={this.gotoView}
          />
        </div>
        <div className="group">
          <Entry
            name={"Add Business"}
            icon={<FontAwesomeIcon icon="home" />}
            color={"#ad5b14"}
            navigate={this.gotoAddBus}
          />
          <Entry
            name={"View Businesses"}
            icon={<FontAwesomeIcon icon="building" />}
            color={"#ad1454"}
            navigate={this.gotoViewBus}
          />
        </div>
        <div className="group">
          <Entry
            name={"Data"}
            icon={<FontAwesomeIcon icon="chart-area" />}
            color={"blue"}
            navigate={this.gotoGraph}
          />
          <Entry
            name={"Tax Calculator"}
            icon={<FontAwesomeIcon icon="calculator" />}
            color={"red"}
            navigate={this.gotoCalculator}
          />
        </div>
        <div className="group">
          <Entry
            name={"Qrcode Scanner"}
            icon={<FontAwesomeIcon icon="qrcode" />}
            color={"gray"}
            navigate={this.gotoQrCode}
          />
          {/* <Entry
            name={"Tax Calculator"}
            icon={<FontAwesomeIcon icon="calculator" />}
            color={"red"}
            navigate={this.gotoCalculator}
          /> */}
        </div>
      </div>
    );
  }
}

export default withRouter(LandingPage);
